import React, { useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from 'react-i18next';
import { Location } from 'history';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';

const TermsDetailPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** Params */
  const { agreeType } = useParams();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL04";
  const screenName = t("APPL04.title");

  /** backKeyEvent_App 처리 (APP > WEB) */
  const callbackBackkeyEvent = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName);
    // 하단바 숨기기
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        {/* 지머니카드 서비스 이용약관 */}
        {agreeType === "cardProductGatradeYn" &&
          <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/gmoneycard_sevice_terms_and_conditions.html`} allowFullScreen={true} title="지머니카드 서비스 이용약관" />
        }
        {/* 개인정보 수집 및 이용 동의 */}
        {agreeType === "uniqDiscriminationNoCollectYn" &&
          <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/consent_to_collection_use_of_personal_information.html`} allowFullScreen={true} title="개인정보 수집 및 이용 동의" />
        }
        {/* 개인정보 제3자 제공 동의 */}
        {agreeType === "personalInfoThirdPartyOfferYn" &&
          <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/consent_form_to_provision_of_personal_information_to_third_parties.html`} allowFullScreen={true} title="개인정보 제3자 제공 동의" />
        }
        {/* 고유식별정보 수집 및 이용 동의 */}
        {agreeType === "uniqDiscriminationNoOfferYn" &&
          <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/consent_to_collection_use_of_unique_identifiable_information.html`} allowFullScreen={true} title="고유식별정보 수집 및 이용 동의" />
        }
        {/* 개인(신용)정보 수집 및 이용동의 */}
        {agreeType === "iniquityUsePreventionOfferYn" &&
          <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/optional_consent_to_prevention_of_personal_information.html`} allowFullScreen={true} title="개인(신용)정보 수집 및 이용동의" />
        }
        {/* 개인(신용)정보 수집 및 이용동의 */}
        {agreeType === "adviceAgree" &&
          <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/optional_consent_to_collection_use_of_personal_information.html`} allowFullScreen={true} title="개인(신용)정보 수집 및 이용동의" />
        }
        {/* 지머니카드 월회비 자동출금 동의 */}
        {agreeType === "cardMonthlyFeeAutomaticWithdrawalYn" &&
            <iframe className="termsDetail" src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/terms_and_condition/optional_consent_to_card_monthly_fee_automatic_withdrawal.html`} allowFullScreen={true} title="지머니카드 월회비 자동출금 동의" />
        }
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button type="button" className="btnPrimaryTy01" onClick={() => navigate(-1)}><span>{t("COMMON.button.done")}</span></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsDetailPage;